<template>
  <div
    class="f-center position-absolute w-100"
    style="left: 0"
  >
    <v-progress-circular
      v-if="loading"
      style="z-index: 100"
      :size="333"
      class="ma-auto position-absolute ma-auto"
      data-tst="overlay_loader"
      :indeterminate="true"
    ></v-progress-circular>

    <div
      ref="cont"
      class="magic-login magic"
      tabindex="1"
      @keydown.enter="magicLogin"
    >
      <div class="ga-2 d-flex mb-4 flex-column">
        <div class="ga-2 d-flex mb-4">
          <span
            class="my-auto text-small text-right"
            style="width: 6rem"
            >TEAM A:</span
          >
          <v-btn
            v-for="item in [
              {
                id: 'loginGtoReportsShortcut',
                fn: loginGtoReportsShortcut,
                html: '📊 <b>gto reports</b>',
              },
              {
                id: 'loginUploadsV4Shortcut',
                fn: loginUploadsV4Shortcut,
                html: '<b>uploads v4</b>',
              },
              {
                id: 'loginHandsV4Shortcut',
                fn: loginHandsV4Shortcut,
                html: '<b>hands v4</b>',
              },
              {
                id: 'loginAnalyzerShortcut',
                fn: loginAnalyzerShortcut,
                html: '<b>analyzer</b>',
              },
              {
                id: 'loginAnalyzerShortcutV1Disabled',
                fn: loginAnalyzerShortcutV1Disabled,
                html: '<b>analyzer</b> V1 disabled',
              },
              {
                id: 'loginAnalyzerShortcut10hands',
                fn: loginAnalyzerShortcut10hands,
                html: '<b>analyzer 10 hands</b>',
              },
              {
                id: 'loginReactMobileMenuShortcut',
                fn: loginReactMobileMenuShortcut,
                html: '<b>react mobile menu</b>',
              },
            ]"
            :key="item.id"
            color="primary"
            :data-tst="item.id"
            @click="item.fn()"
          >
            <span v-html="item.html"></span>
          </v-btn>
        </div>
        <div class="ga-2 d-flex mb-4">
          <span
            class="my-auto text-small text-right"
            style="width: 6rem"
            >TEAM STUDY:</span
          >
          <v-btn
            v-for="item in [
              {
                id: 'loginNodeLockV2Shortcut',
                fn: loginNodeLockV2Shortcut,
                html: '<b>NODELOCK V2</b>',
              },
              {
                id: 'loginThreeWay',
                fn: loginThreeWay,
                html: '<b>3WAY</b>',
              },
              {
                id: 'loginStudyReportsSplit',
                fn: loginStudyReportsSplit,
                html: '<b>Custom reports - CR_REPORTS</b>',
              },
              {
                id: 'loginFinalTableIcmShortcut',
                fn: loginFinalTableIcmShortcut,
                html: '<b>Final table ICM</b>',
              },
              {
                id: 'loginPOKERWIZshortcut',
                fn: loginPOKERWIZshortcut,
                html: 'login <b>POKERWIZ</b>',
              },
              {
                id: 'loginCustomSolutionsShortcut',
                fn: loginCustomSolutionsShortcut,
                html: 'login <b>CUSTOM SOLUTIONS</b>',
              },
              {
                id: 'loginCreditsBalance',
                fn: loginCreditsBalance,
                html: 'login <b>CREDITS BALANCE</b>',
              },
            ]"
            :key="item.id"
            color="primary"
            :data-tst="item.id"
            @click="item.fn()"
          >
            <span v-html="item.html"></span>
          </v-btn>
        </div>
        <div class="card">
          <h2
            class="text-small text-right"
            style="width: 6rem"
          >
            💰 PAYMENTS
          </h2>
          <div
            class="d-flex mb-2"
            style="gap: 0.5rem; align-self: flex-start"
          >
            <v-btn
              color="warning"
              data-tst="loginPayments"
              @click="
                loginPayments({
                  adyenEnabled,
                  confirmoEnabled,
                  alipayEnabled,
                  wechatPayEnabled,
                  cryptoUpgradesEnabled,
                  payPalEnabled,
                })
              "
            >
              🤑 Proceed to Payment
            </v-btn>
            <v-checkbox
              v-model="confirmoEnabled"
              label="Confirmo"
              class="checkbox"
            ></v-checkbox>
            <v-checkbox
              v-model="alipayEnabled"
              label="Alipay"
              class="checkbox"
            ></v-checkbox>
            <v-checkbox
              v-model="wechatPayEnabled"
              label="WeChat Pay"
              class="checkbox"
            ></v-checkbox>
            <v-checkbox
              v-model="adyenEnabled"
              label="Adyen"
              class="checkbox"
            ></v-checkbox>
            <v-checkbox
              v-model="cryptoUpgradesEnabled"
              label="Crypto Upgrades"
              class="checkbox"
            ></v-checkbox>
            <v-checkbox
              v-model="payPalEnabled"
              label="PayPal"
              class="checkbox"
            ></v-checkbox>
          </div>
        </div>
      </div>

      <v-btn
        color="error"
        @click="magicReset()"
        >clear all</v-btn
      >

      <div class="d-flex mt-4">
        <div class="f-row justify-space-between w-100">
          <div class="d-f-column">
            <div class="text-small">SOCIAL LOGIN</div>
            <div class="mt-2">
              <v-btn @click="setSpecial(), $emit('login:google')">GOOGLE</v-btn>
              <v-btn
                class="ml-2"
                @click="setSpecial(), $emit('login:facebook')"
                >FACEBOOK</v-btn
              >
              <div id="google-button-anchor"></div>
            </div>
            <div class="w-100 text-small pl-4 mt-4">NOTES</div>
            <ul class="notes text-small clr-grey">
              <li class="">
                to tst RAKE not allowed for ELITE sub log as ELITE MTT and create solution with rake
                (then check 403 with flag response)
              </li>
              <li>
                for tests to work correctly, re-record mocks every time any parameter changes in
                magic login
              </li>
            </ul>

            <div class="w-100 text-small pl-4 mt-4">
              MAGIC LOGIN (2nd click or Enter to confirm)
            </div>
            <div
              class="d-flex w-100 mt-2 ch-param f-wrap"
              style="padding-bottom: 0"
            >
              <div
                v-for="item in presets"
                :key="item.id"
                :color="quickPreset === item.id ? 'primary' : ''"
                :data-tst="item.id.toLowerCase()"
                class="gw_btn mr-2 mb-2"
                @click="setPreset(item)"
              >
                {{ item.id }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 text-small mt-4 pl-4">SITUATION</div>
      <div class="d-flex flex-wrap">
        <CheckboxRow
          v-for="(value, key, eIdx) in extraRows"
          :key="`${key}_${eIdx}`"
          :styleCheckbox="'--checkbox-btn-size:0.8rem;--checkbox-btn-padding:0.125rem 0.5rem'"
          style="--title-size: 0.8rem"
          class="ch-param"
          :item="value"
          :hasAny="false"
          :isSingle="true"
          :data-tst="key"
          @update="v => (extra[key] = v.selected[0])"
        >
          <template #default="v">
            {{ v.id }}
          </template>
        </CheckboxRow>
      </div>

      <div class="w-100 text-small mt-4 pl-4">USER-SETTINGS</div>
      <div class="d-flex flex-wrap">
        <CheckboxRow
          v-for="(value, key, eIdx) in userSettingsRows"
          :key="`${key}_${eIdx}`"
          :styleCheckbox="'--checkbox-btn-size:0.8rem;--checkbox-btn-padding:0.125rem 0.5rem'"
          style="--title-size: 0.8rem"
          class="ch-param"
          :item="value"
          :hasAny="false"
          :isSingle="true"
          @update="v => (userSettings[key] = v.selected[0])"
        >
          <template #default="v">
            {{ value.dict ? value.dict[v.id] : v.id }}
          </template>
        </CheckboxRow>
      </div>

      <div class="d-flex f-wrap">
        <div class="mt-4 pl-4">
          <div>
            <div class="text-small">USER-SETTINGS</div>
            <input
              data-tst="usersettings_input"
              type="text"
              autocorrect="off"
              style="background: white; color: black"
              @input="e => handleUserSettingsInput(e)"
            />
          </div>
        </div>

        <div class="mt-4 pl-4">
          <div class="d-flex">
            <div class="text-small my-auto">LOCALSTORAGE</div>
            <div
              class="gw_btn gw_btn_small mr-auto ml-2"
              @click="copyLocalStorage()"
            >
              copy
            </div>
          </div>
          <input
            data-tst="localstorage_input"
            type="text"
            autocorrect="off"
            style="background: white; color: black"
            @input="e => handleLocalStorageInput(e)"
          />
        </div>

        <div class="mt-4 w-100">
          <div class="pl-4 d-flex">
            <div class="text-small my-auto">FEATURE-FLAGS</div>
          </div>
          <div class="f-column flex-wrap pl-4">
            <input
              v-model="feature_flags"
              type="text"
              autocorrect="off"
              style="background: white; color: black"
            />
            <div
              class="f-column mt-2 mr-auto"
              style="gap: 0.25rem"
            >
              <div
                class="gw_btn gw_btn_small ml-2"
                style="--clr-back: var(--clr-blue-1)"
                @click="feature_flags = flagOptions.join(',')"
              >
                ALL FLAGS
              </div>
              <div
                v-for="flag in flagOptions"
                :key="flag"
                class="gw_btn gw_btn_small ml-2"
                @click="feature_flags = feature_flags + ',' + flag"
              >
                {{ flag }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 text-small mt-4 pl-4">SPECIAL</div>
      <div class="d-flex flex-wrap">
        <CheckboxRow
          v-for="(value, key, eIdx) in specialRows"
          :key="`${key}_${eIdx}`"
          :styleCheckbox="'--checkbox-btn-size:0.8rem;--checkbox-btn-padding:0.125rem 0.5rem'"
          style="--title-size: 0.8rem"
          class="ch-param"
          :item="value"
          :hasAny="false"
          :isSingle="true"
          @update="v => (specialSettings[key] = v.selected[0])"
        >
          <template #default="v">
            {{ value.dict ? value.dict[v.id] : v.id }}
          </template>
        </CheckboxRow>
      </div>

      <div class="pl-4 mr-auto">
        <div class="d-flex w-100 mt-2 f-wrap">
          <v-btn
            class="ml-2"
            @click="add"
            >+</v-btn
          >
          <v-btn
            class="ml-2"
            @click="remove"
            >-</v-btn
          >
          <div
            color="primary"
            class="gw_btn gw_btn_primary gw_btn_large ml-4"
            data-tst="btn_login"
            @click="magicLogin"
          >
            LOGIN
          </div>
        </div>

        <div
          class="mt-4 mr-auto"
          style="display: grid; grid-template-rows: repeat(5, 1fr); grid-auto-flow: column"
        >
          <div
            v-for="route in magicLinks"
            :key="route.name"
            class="mr-4 csst"
            @click.stop="logInToPage(`${route.path}/?${route.query}`)"
          >
            --
            <span class="text-underline_hover clr-primary cursor-pointer weight_700">
              {{ route.name }}
            </span>
            <div class="csst_content text-normal">
              <!-- {{ route.path.split('&') }} -->
              <div
                v-for="item in route.query.split('&')"
                :key="item"
                class="text-nowrap"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-for="(subscription, idx) in subRows"
          :key="idx"
          class="magic_sub d-flex flex-wrap mt-2"
          :style="getValid(idx, subscription, subRows) ? '' : `box-shadow:0px 0px 0px 2px red`"
        >
          <CheckboxRow
            v-for="(item, key, kIdx) in getSubRow(subscription)"
            v-show="params.subscriptions[idx][key]"
            :key="`${idx}_${kIdx}`"
            :styleCheckbox="'--checkbox-btn-size:0.8rem;--checkbox-btn-padding:0.125rem 0.5rem'"
            style="--title-size: 0.8rem"
            class="ch-param"
            :item="item"
            :hasAny="false"
            :isSingle="true"
            @update="v => updateSubscription(idx, key, v)"
          >
            <template #default="v">
              {{ v.id }}
            </template>
          </CheckboxRow>
        </div>

        <div class="d-flex f-wrap mt-4">
          <div class="mr-4">
            <div
              v-for="route in sitemap"
              :key="route.path"
            >
              <span
                class="link-underline link-underline_hover clr-primary cursor-pointer weight_700"
                @click.stop="logInToPage(route.path)"
              >
                {{ route.name }}
              </span>

              <div
                v-for="rChild in route.children || []"
                :key="rChild.path"
              >
                <span
                  class="link-underline link-underline_hover clr-primary cursor-pointer"
                  @click.stop="logInToPage(`${route.path}/${rChild.path}`)"
                >
                  {{ rChild.name }}
                </span>
              </div>
            </div>
          </div>
          <div>
            <pre class="text-small">{{ JSON.stringify(params, undefined, 2) }}</pre>
          </div>
          <div>
            <h2 class="mt-4">LocalStorage</h2>
            <pre
              class="text-small break-all w-100 max-h-300 overflow-auto p-2 bg-dark border border-secondary rounded px-2"
            >
              <code>{{ formattedLocalStorage }}</code>
            </pre>
          </div>
        </div>
      </div>
      <div class="text-small">TEST-PARAMS</div>
      <input
        data-tst="test_params"
        type="text"
        autocorrect="off"
        style="background: white; color: black"
        @input="e => handleTestParamsInput(e)"
      />
    </div>
  </div>
</template>

<script>
// doc
// https://cotton-shadow-79c.notion.site/Magic-login-fa0a597ddc704fe18dc7b283a83fd92d

// pass: gtowiz888
// gtowizardstartermo@gmail.com
// gtowizardstarteryr@gmail.com
// gtowizardpremiummo@gmail.com
// gtowizardpremiumyr@gmail.com

import CheckboxRow from '@/components/Forms/CheckboxRow'
import routes from '@/router/routes'
import { merge, omit } from 'lodash'
import { defaultTours } from '@/store/userSettings/settingsDefaults'
import { getMagicLinks } from './magicShortcuts'

export default {
  name: 'MagicLogin',
  components: {
    CheckboxRow,
  },
  emits: [
    'login:google', //
    'login:facebook',
  ],
  data() {
    return {
      flagOptions: [
        // new features - not time tested
        'REACT_MOBILE_MENU',

        // not public features
        'CONFIRMO',
        'CONFIRMO_UPGRADES',
        'ADYEN',
        'ALIPAY',
        'WECHAT_PAY',
        'GTO_REP_BANNER',
        'NOLT',
        'HHV2',
        'CHAT_WIDGET',
        'POKERWIZ',
        'NODELOCK_V2',
        'HANDS_V4',

        // banner flags
        'BANNER_ANALYZER',
        'BANNER_POKERWIZ_MATCHMAKING',
        'BANNER_POKERWIZ',
        'BANNER_EVENTS',
        'BOOTCAMP',
        'BOOTCAMP_SOLD_OUT',

        // custom reports
        'CR_REPORTS',
        'FINAL_TABLE_ICM',

        // multiway solutions - 3way
        'SOL_3WAY',

        // old features - timetested - can be deleted

        // temporary flags
        'GMF_SURVEY', // survey
        'FORCED_MANUAL_UPGRADE',
        'ANALYZER_BBWL_ENABLED',

        // dev flags
        'GATESBTNS', // show payment paypal/stripe btns
        'TTEAM', // translations
        'UNLIMITEDFAIRPLAY', // fairplay
        'GMF_SHOW_HIDDEN', // show hidden gametypes/gameformats

        // gto reports
        'GTO_REP_BANNER',
        'GTO_REP',
        'GTO_REPORTS_FLOP',
        'GTO_REPORTS_TURN',
        'GTO_REPORTS_RIVER',
        'GTO_REPORTS_AGGREGATE',

        // uploads
        'UPLOADS_V4_HEADER_NAVIGATION',
        'UPLOADS_EXPORT',

        // hands
        'HANDS_V4',

        // analyzer
        'ANALYZER_SIDEBAR',
      ],
      loading: false,
      quickPreset: 'starter_1',
      localStorageState: {},
      magicLinks: getMagicLinks(),
      subscriptions_opts: {
        tier: ['FREE', 'TRIAL', 'STARTER', 'PREMIUM', 'ELITE'],
        interval: ['MONTHLY', 'YEARLY'],
        type: [
          'CASH',
          'STRADDLE_ANTE_CASH',
          'MTT',
          'SPINS',
          'HUSNG',
          // 'SHORTDECK',
          // 'STRADDLE_ANTE_CASH',
          // 'ANY',
        ],
        provider: ['Stripe', 'Paypal', 'Gtowizard'],
        future_plan: [false, true],
        // expired: [false, true],
      },
      feature_flags: '',
      // discord_tag: [false, true],
      // new_user: [false, true],
      // affiliate: [false, true],
      // discount_available: [false, true],
      // analyzer_limit_full: [false, true],
      subscriptions: [
        {
          tier: 'FREE',
        },
        {
          tier: 'STARTER',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
          // expired: false,
          future_plan: false,
        },
      ],
      extra: {
        // has_custom_solutions: true,
        has_v3_hands: true,
        has_solved_hands: false,
        opened_reports_amount: 0,
        saved_reports_amount: 0,
        v3_hands_amount: 0,
        wait_for_reports: false,

        has_preflop_custom_report: false,
        has_flop_custom_report: false,

        // ICM custom solving
        preset_tournaments_count: 0,

        has_custom_solutions: false,
        discord_tag: false,
        new_user: false,
        affiliate: false,
        discount_available: false,
        analyzer_limit_full: false,
        update_grpc_cache: false,
        // has_drills: true,
        has_drills: false,
        // more_hands: true,
        more_hands: false,
        adyen_saved_card: false,
        // new_content_items_amount: 333,
        new_content_items_amount: 0,
        // delete_content: true,
        delete_content: false,
        // has_hand_history_reports: true,
        credit_balance: 0,
      },
      userSettings: {
        // miscs: {
        show_legacy_solutions: true,
        sw_actions_grouping: 'swv_grouping_none',
        // },
      },
      specialSettings: {
        G1_no_poker_word: false,
      },
      mockResponse: {
        client: false,
        indexing: true,
        recording: false,
        uniqueByTestName: false,
        save_canceled_requests: false,
        delays: '',
      },
      adyenEnabled: true,
      confirmoEnabled: true,
      alipayEnabled: true,
      wechatPayEnabled: true,
      cryptoUpgradesEnabled: true,
      payPalEnabled: true,
    }
  },
  created() {
    this.saveLoginPreset(this.quickPreset)
    // const handleCredentialResponse = credentialData => {
    //   const gclid = getCookie('GTO_GCLID')
    //   let affiliate_id = ''
    //   let aid = getCookie('GTO_AFFILIATE_ID')
    //   if (aid) {
    //     affiliate_id = aid
    //     gtm_refferal_link()
    //   }
    //   let data = {
    //     id_token: credentialData.credential,
    //     provider: 'google-plus',
    //     gclid,
    //     appUid: this.$store.getters.appUid,
    //     affiliate_id,
    //     redirect_uri: `${window.origin}/${'login'}`,
    //   }
    //   console.log('google-credential-data', credentialData)
    //   console.log('login-data', data)
    //   this.$store.dispatch('login', data)
    //   deleteCookie('GTO_GCLID')
    // }
    /*
    Tom needs to allow 'http://127.0.0.1:8080/' in google console, cos now this throws error which breaks tests
    right now this is not used but whe we use it we need to fix this

    this.$loadScript('https://accounts.google.com/gsi/client').then((ss) => {
      console.log('google script loaded')
      const google = window.google
      if (window.google) {
        google.accounts.id.initialize({
          client_id: '984101650159-3ibpei4p5m5j5j97qu7j13jtb4i664td.apps.googleusercontent.com',
          callback: handleCredentialResponse, // popups only
          ux_mode: 'popup',
          login_uri: 'https://api.dev.gtowizard.com/v1/account/login/',
        })
        console.log(google)
        // https:// accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?access_type=online&approval_prompt=auto&client_id=917071888555.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Fwww.quora.com%2Fgoogle_%2Fcallback&response_type=code&scope=email%20profile&state=eyJwZXJtcyI6ICJub19jb250YWN0cyIsICJjc3JmIjogIjI5MmUzZWM2YmI5NGM1ZjJkYTBhOGRiYjE1NDcxMDVmIiwgInBsYXRmb3JtIjogImRlc2t0b3AiLCAidGFyZ2V0IjogInNpZ251cCJ9&service=lso&o2v=2&flowName=GeneralOAuthFlow
        // https://stackoverflow.com/questions/62281579/google-one-tap-sign-in-ui-not-displayed-after-clicking-the-close-button
        // https://github.com/piraces/GoogleOneTapSample
        // https://piraces.dev/posts/how-to-use-google-one-tap/
        google.accounts.id.renderButton(
          document.getElementById('google-button-anchor'),
          {
            theme: 'outline',
            size: 'large',
          }, // customization attributes
        )
        // google.accounts.id.prompt((notification) => {
        //   console.log('prompt', notification)
        //   if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        //     document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`
        //     google.accounts.id.prompt()
        //   }
        // })
      }
    })
    */
  },
  mounted() {
    this.$refs.cont.focus()
    this.localStorageState = { ...localStorage }
    console.log('localStorageState', this.localStorageState)
  },

  methods: {
    loginGtoReportsShortcut() {
      this.feature_flags =
        'GTO_REP, GTO_REP_BANNER, GTO_REPORTS_FLOP, GTO_REPORTS_TURN, GTO_REPORTS_RIVER, GTO_REPORTS_AGGREGATE'
      this.subscriptions = [
        {
          tier: 'ELITE',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
        },
      ]
      localStorage.setItem('redirect', '/analyze/reports')
      this.magicLogin()
    },
    loginUploadsV4Shortcut() {
      this.feature_flags = 'UPLOADS_V4_HEADER_NAVIGATION, UPLOADS_EXPORT'
      localStorage.setItem('redirect', '/analyze/v4/uploads')
      this.magicLogin()
    },
    loginHandsV4Shortcut() {
      this.feature_flags = 'HANDS_V4'
      localStorage.setItem('redirect', '/analyze/v4/hands')
      this.extra.has_v3_hands = true
      this.extra.v3_hands_amount = 100
      this.subscriptions = [
        {
          tier: 'ELITE',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
        },
      ]
      this.magicLogin()
    },
    loginNodeLockV2Shortcut() {
      this.feature_flags = 'NODELOCK_V2'
      localStorage.setItem('redirect', '/study')
      this.magicLogin()
    },
    loginStudyReportsSplit() {
      this.feature_flags = 'CR_REPORTS'
      this.extra.credit_balance = 1000
      this.extra.has_preflop_custom_report = true
      this.extra.has_flop_custom_report = true
      this.subscriptions = [
        {
          tier: 'ELITE',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
        },
      ]
      localStorage.setItem('redirect', '/study')
      this.magicLogin()
    },
    loginFinalTableIcmShortcut() {
      this.feature_flags = 'FINAL_TABLE_ICM'
      localStorage.setItem('redirect', '/study')
      this.magicLogin()
    },
    loginThreeWay() {
      this.feature_flags = 'SOL_3WAY'
      this.subscriptions = [
        {
          tier: 'ELITE',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
        },
      ]
      localStorage.setItem('redirect', '/study')
      this.magicLogin()
    },
    loginAnalyzerShortcut() {
      this.extra.has_solved_hands = true
      this.extra.opened_reports_amount = 10
      this.extra.saved_reports_amount = 10
      this.extra.more_hands = false
      this.extra.wait_for_reports = false
      this.feature_flags = 'HHV2, BANNER_ANALYZER'
      this.subscriptions = [
        {
          tier: 'ELITE',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
        },
      ]
      localStorage.setItem('redirect', '/analyze/v3/hands')
      this.magicLogin()
    },
    loginAnalyzerShortcutV1Disabled() {
      this.extra.has_solved_hands = true
      this.extra.opened_reports_amount = 10
      this.extra.saved_reports_amount = 10
      this.extra.more_hands = false
      this.extra.wait_for_reports = false
      this.feature_flags = 'HHV2, BANNER_ANALYZER'
      this.subscriptions = [
        {
          tier: 'ELITE',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
        },
      ]
      localStorage.setItem('redirect', '/analyze/v3/hands')
      this.magicLogin()
    },
    loginAnalyzerShortcut10hands() {
      this.extra.v3_hands_amount = 10
      this.loginAnalyzerShortcut()
    },
    loginPayments({
      adyenEnabled = true,
      confirmoEnabled = true,
      alipayEnabled = true,
      wechatPayEnabled = true,
      cryptoUpgradesEnabled = true,
      payPalEnabled = true,
    }) {
      const flags = []

      if (adyenEnabled) flags.push('ADYEN')
      if (confirmoEnabled) flags.push('CONFIRMO')
      if (alipayEnabled) flags.push('ALIPAY')
      if (wechatPayEnabled) flags.push('WECHAT_PAY')
      if (cryptoUpgradesEnabled) flags.push('CONFIRMO_UPGRADES')
      if (payPalEnabled) flags.push('GATESBTNS')
      this.feature_flags = flags.join(', ')
      localStorage.setItem(
        'redirect',
        '/subscription/payment-gate?gm_type=spins&gm_tier=starter&gm_interval=yearly',
      )
      this.subscriptions = [
        {
          tier: 'FREE',
        },
      ]
      this.magicLogin()
    },
    loginReactMobileMenuShortcut() {
      this.feature_flags = 'REACT_MOBILE_MENU, CHAT_WIDGET, NOLT, GTO_REP'
      this.subscriptions = [
        { tier: 'ELITE', type: 'CASH', provider: 'Stripe', interval: 'MONTHLY' },
      ]
      localStorage.setItem('redirect', '/')
      this.magicLogin()
    },
    loginPOKERWIZshortcut() {
      this.feature_flags = 'BANNER_POKERWIZ, POKERWIZ'
      this.subscriptions = [
        {
          tier: 'ELITE',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
        },
      ]
      localStorage.setItem('redirect', '/play')
      this.magicLogin()
    },
    loginCustomSolutionsShortcut() {
      this.feature_flags = 'CR_REPORTS'
      this.subscriptions = [
        { tier: 'ELITE', type: 'CASH', provider: 'Stripe', interval: 'MONTHLY' },
      ]
      localStorage.setItem('redirect', '/solutions?soltab=reports')
      this.magicLogin()
    },
    loginCreditsBalance() {
      this.feature_flags = 'CR_REPORTS'
      this.extra.credit_balance = 100
      this.extra.credit_spending_count = 9
      this.subscriptions = [
        { tier: 'ELITE', type: 'CASH', provider: 'Stripe', interval: 'MONTHLY' },
      ]
      localStorage.setItem('redirect', '/user/credits')
      this.magicLogin()
    },
    copyLocalStorage() {
      const text = JSON.stringify({ ...localStorage })
      navigator.clipboard.writeText(text)
    },

    handleLocalStorageInput(e) {
      const text = e.target.value
      console.log(text)
      try {
        const data = JSON.parse(text)
        Object.keys(data).forEach(key => {
          console.log(key, data[key])
          localStorage.setItem(key, data[key])
        })
        this.localStorageState = data
      } catch (error) {
        console.warn('handleLocalStorageInput -- Invalid JSON')
      }
    },
    handleUserSettingsInput(e) {
      const text = e.target.value
      try {
        const data = JSON.parse(text)
        this.userSettings = data
      } catch (error) {
        //
        console.error('handleUserSettingsInput -- Invalid JSON')
      }
    },
    handleTestParamsInput(e) {
      const { value } = e.target
      const data = JSON.parse(value)
      this.testParams = data
    },
    logInToPage(path) {
      // console.log(path)
      localStorage.setItem('redirect', path)
      this.magicLogin()
    },
    magicReset() {
      localStorage.clear()
      this.localStorageState = { ...localStorage }
    },
    setSpecial() {
      if (this.specialSettings.G1_no_poker_word) {
        localStorage.setItem('G1_no_poker_word', 'magic-enabled')
      } else {
        localStorage.removeItem('G1_no_poker_word')
      }
      if (this.extra.wait_for_reports) {
        localStorage.setItem('wait_for_reports', 'true')
      } else {
        localStorage.removeItem('wait_for_reports')
      }
    },
    saveLoginPreset(id) {
      localStorage.setItem('loginPreset', id.toUpperCase().replace('_', ''))
    },
    setMockResponse() {
      if (this.mockResponse.client !== 'Off') {
        localStorage.setItem('mockResponse', JSON.stringify(this.mockResponse))
      } else {
        localStorage.removeItem('mockResponse')
      }
      localStorage.setItem('usedMockRequestCacheIds', '[]')
    },
    magicLogin() {
      this.setSpecial()
      this.setMockResponse()
      const params = merge(this.params, this.testParams)
      if (params?.new_user) {
        localStorage.clear()
      } else {
        params.settings.tours = Object.keys(defaultTours()).reduce((acc, key) => {
          acc[key] = 'finished'
          return acc
        }, {})
      }
      this.loading = true
      this.$store.dispatch('login', {
        magicLogin: true,
        ...params,
      })
    },
    add() {
      let subscriptions = [
        ...this.subscriptions,
        {
          tier: 'STARTER',
          type: 'CASH',
          provider: 'Stripe',
          interval: 'MONTHLY',
          future_plan: false,
          // expired: false,
        },
      ]
      if (subscriptions.length !== 4) {
        subscriptions[0] = { tier: 'FREE' }
      }

      if (subscriptions.length > 4) {
        subscriptions = subscriptions.slice(1, 999)
      }

      this.subscriptions = subscriptions
      this.quickPreset = ''

      // console.log(this.subscriptions)
    },
    remove() {
      let subscriptions = [...this.subscriptions]
      if (subscriptions.length > 1) {
        subscriptions = subscriptions.slice(0, subscriptions.length - 1)
      }
      if (
        subscriptions.length < 4 &&
        !subscriptions.some(s => s.tier === 'FREE' || s.tier === 'TRIAL')
      ) {
        subscriptions = [{ tier: 'FREE' }, ...subscriptions].slice(0, 4)
      }
      this.subscriptions = subscriptions
      this.quickPreset = ''
    },
    setPreset({ id, subs, extra }) {
      this.saveLoginPreset(id)
      this.subscriptions = subs
      this.extra = extra || this.extra

      if (this.quickPreset === id) {
        this.magicLogin()
        return
      }
      this.quickPreset = id
    },
    updateSubscription(idx, key, v) {
      let { subscriptions } = this
      // let subscriptions = JSON.parse(JSON.stringify(this.subscriptions))
      subscriptions[idx][key] = v.selected[0]

      subscriptions = subscriptions.map(i => {
        if (i.type === 'STRADDLE_ANTE_CASH') {
          return {
            ...i,
            tier: 'PREMIUM',
          }
        }
        return i
      })

      this.subscriptions = subscriptions
      // debugger
      if (this.subscriptions[0].tier === 'TRIAL') {
        this.subscriptions = [this.subscriptions[0]]
      }
      this.quickPreset = ''
    },
    getSubRow(sub) {
      return omit(sub, 'valid')
    },
    getValid(idx, sub, subRows) {
      let valid = false
      const other = subRows.filter((j, jdx) => jdx !== idx)
      if (other.some(v => v.type?.selected?.[0] === sub.type?.selected?.[0])) {
        valid = false
      } else {
        valid = true
      }
      return valid
    },
    updatePaymentMethods({ selected }) {
      this.confirmoEnabled = selected.includes('Confirmo')
      this.alipayEnabled = selected.includes('Alipay')
      this.wechatPayEnabled = selected.includes('WeChat Pay')
      this.adyenEnabled = selected.includes('Adyen')
      this.cryptoUpgradesEnabled = selected.includes('Crypto Upgrades')
    },
  },
  computed: {
    formattedLocalStorage() {
      const beautify = obj => {
        const parsed = {}
        Object.keys(obj).forEach(key => {
          try {
            parsed[key] = JSON.parse(obj[key])
          } catch {
            parsed[key] = obj[key]
          }
        })
        return JSON.stringify(parsed, null, 2)
      }
      return beautify(this.localStorageState)
    },
    vite_env() {
      return import.meta.env.VITE_ENV
    },
    sitemap() {
      // console.log(routes)
      const hidden = ['NotFound', 'Login']
      const res = routes.filter(i => !hidden.includes(i.name))
      return res.reverse()
    },
    presets() {
      const free = { tier: 'FREE' }

      const starter = this.subscriptions_opts.type.map(type => ({
        tier: 'STARTER',
        type,
        provider: 'Stripe',
        interval: 'MONTHLY',
        // expired: false,
        future_plan: false,
      }))

      const premium = this.subscriptions_opts.type.map(type => ({
        tier: 'PREMIUM',
        type,
        provider: 'Stripe',
        interval: 'MONTHLY',
        // expired: false,
        future_plan: false,
      }))

      const elite = this.subscriptions_opts.type.map(type => ({
        tier: 'ELITE',
        type,
        provider: 'Stripe',
        interval: 'MONTHLY',
        // expired: false,
        future_plan: false,
      }))

      let res = [
        {
          id: 'FREE',
          subs: [free],
        },
        {
          id: 'TRIAL',
          subs: [{ tier: 'TRIAL' }],
        },
        {
          id: 'starter_1',
          subs: [free, starter[0]],
        },
        {
          id: 'starter_2',
          subs: [free, starter[0], starter[1]],
        },
        {
          id: 'starter_3',
          subs: [free, starter[0], starter[1], starter[2]],
        },
        {
          id: 'starter_4',
          subs: [free, ...starter],
        },
        {
          id: 'premium_1',
          subs: [free, premium[0]],
        },
        {
          id: 'premium_2',
          subs: [free, premium[0], premium[1]],
        },
        {
          id: 'premium_3',
          subs: [free, premium[0], premium[1], premium[2]],
        },
        {
          id: 'premium_4',
          subs: [free, ...premium],
        },
        {
          id: 'premium_mtt',
          subs: [free, premium[1]],
        },
        {
          id: 'elite',
          subs: [free, ...elite],
        },
      ]

      res = res.map(i => ({
        ...i,
        subs: i.subs.map(s => {
          if (s.type === 'STRADDLE_ANTE_CASH') {
            return {
              ...s,
              tier: 'PREMIUM',
            }
          }
          return s
        }),
      }))

      // console.log(res)

      return res
    },
    userSettingsParams() {
      return {
        ...this.userSettings,
        // Flags, and any other stuff that you want your test to have
        // this will result in some mismatch and clutter as Fe can store anythin here
        // but for the tests it dont matter
        settings: {
          misc: {
            show_legacy_solutions: this.userSettings.show_legacy_solutions,
            switchers_defaults: {
              sw_actions_grouping: this.userSettings.sw_actions_grouping,
            },
          },
          colors: this.userSettings.colors || {},
        },
      }
    },
    feature_flagsParams() {
      const feature_flags = this.feature_flags
        .split(',')
        .map(i => i.trim())
        .map(i => i.toUpperCase())
        .filter(i => i)
      return {
        flags: feature_flags,
      }
    },
    params() {
      const subscriptions = this.subscriptions.map(sub => {
        const { tier } = sub
        const d = tier === 'FREE' || tier === 'TRIAL'

        const r = {
          tier,
          ...(!d ? { type: sub.type } : {}),
          ...(!d ? { provider: sub.provider } : {}),
          ...(!d ? { interval: sub.interval } : {}),
          ...(!d && sub.future_plan ? { future_plan: sub.future_plan } : {}),
          // ...!d && sub.expired ? { expired: true } : {},
        }

        return r
      })
      const res = {
        subscriptions,
        update_grpc_cache: this.extra.update_grpc_cache,

        ...(this.extra.has_preflop_custom_report ? { has_preflop_custom_report: true } : {}),
        ...(this.extra.has_flop_custom_report ? { has_flop_custom_report: true } : {}),

        ...(this.extra.has_v3_hands ? { has_v3_hands: true } : {}),
        ...(this.extra.has_solved_hands ? { has_solved_hands: true } : {}),
        ...(!!this.extra.opened_reports_amount || !!this.extra.saved_reports_amount
          ? {
              has_hand_history_reports: true,
              opened_reports_amount: this.extra.opened_reports_amount,
              saved_reports_amount: this.extra.saved_reports_amount,
              v3_hands_amount: this.extra.v3_hands_amount,
              credit_balance: this.extra.credit_balance,
              credit_spending_count: this.extra.credit_spending_count,
            }
          : {}),

        ...(this.extra.preset_tournaments_count
          ? { preset_tournaments_count: this.extra.preset_tournaments_count }
          : {}),

        ...(this.extra.has_custom_solutions ? { has_custom_solutions: true } : {}),
        ...(this.extra.discord_tag ? { discord_tag: true } : {}),
        ...(this.extra.new_user ? { new_user: true } : {}),
        ...(this.extra.affiliate ? { affiliate: true } : {}),
        ...(this.extra.discount_available ? { discount_available: true } : {}),
        ...(this.extra.analyzer_limit_full ? { analyzer_limit_full: true } : {}),
        ...(this.extra.has_drills ? { has_drills: true } : {}),
        ...(this.extra.more_hands ? { more_hands: true } : {}),
        ...(this.feature_flags.includes('ADYEN') && {
          adyen: this.extra.adyen_saved_card ? 'SAVED_CARD' : 'NO_CARD',
        }),
        ...(this.extra.v3_hands_amount ? { v3_hands_amount: this.extra.v3_hands_amount } : {}),
        ...(this.extra.new_content_items_amount
          ? { new_content_items_amount: this.extra.new_content_items_amount }
          : {}),
        ...(this.extra.delete_content ? { delete_content: true } : {}),
        ...this.feature_flagsParams,
        ...this.userSettingsParams,
        ...(this.extra.credit_balance ? { credit_balance: this.extra.credit_balance } : {}),
        ...(this.extra.credit_spending_count
          ? { credit_spending_count: this.extra.credit_spending_count }
          : {}),
      }

      console.log('magic-params', res)
      return res
    },
    subRows() {
      const res = this.subscriptions.map(subscription => {
        const ss = {}
        // console.log(subscription)
        Object.keys(subscription).forEach(key => {
          if (subscription[key] === 'FREE' || subscription[key] === 'TRIAL') {
            ss[key] = {
              id: key,
              title: key,
              selected: [subscription[key]],
              options: ['FREE', 'TRIAL'],
            }
          } else if (key === 'tier') {
            const { type } = subscription
            const disabled = type === 'STRADDLE_ANTE_CASH' ? ['STARTER'] : []
            const selected = type === 'STRADDLE_ANTE_CASH' ? ['PREMIUM'] : [subscription[key]]
            ss[key] = {
              id: key,
              title: key,
              selected,
              options: ['STARTER', 'PREMIUM', 'ELITE'],
              disabled,
            }
          } else if (key !== 'valid') {
            ss[key] = {
              id: key,
              title: key,
              selected: [subscription[key]],
              options: [...this.subscriptions_opts[key]],
            }
          }
        })
        return ss
      })

      // console.log(res)
      return res
    },
    // canConfirm() {
    //   return this.subRows.every(i => i.valid)
    // },
    extraRows() {
      const getOpt = (key, options) => {
        const r = {
          id: key,
          title: key,
          selected: [this.extra[key]],
          options: options || [false, true],
        }
        return r
      }

      const nums = [0, 10, 100, 1000]
      const res = {
        // has_hand_history_reports: getOpt('has_hand_history_reports'),
        has_preflop_custom_report: getOpt('has_preflop_custom_report'),
        has_flop_custom_report: getOpt('has_flop_custom_report'),

        has_v3_hands: getOpt('has_v3_hands'),
        has_solved_hands: getOpt('has_solved_hands'),
        opened_reports_amount: getOpt('opened_reports_amount', nums),
        saved_reports_amount: getOpt('saved_reports_amount', nums),
        more_hands: getOpt('more_hands'),
        adyen_saved_card: getOpt('adyen_saved_card'),
        v3_hands_amount: getOpt('v3_hands_amount', nums),
        wait_for_reports: getOpt('wait_for_reports'),

        preset_tournaments_count: getOpt('preset_tournaments_count', nums),

        has_custom_solutions: getOpt('has_custom_solutions'),
        discord_tag: getOpt('discord_tag'),
        new_user: getOpt('new_user'),
        affiliate: getOpt('affiliate'),
        discount_available: getOpt('discount_available'),
        analyzer_limit_full: getOpt('analyzer_limit_full'),
        has_drills: getOpt('has_drills'),
        new_content_items_amount: getOpt('new_content_items_amount', nums),
        delete_content: getOpt('delete_content'),
        update_grpc_cache: getOpt('update_grpc_cache'),

        credit_balance: getOpt('credit_balance', nums),
        credit_spending_count: getOpt('credit_spending_count', [0, 2, 9]),
      }
      return res
    },
    userSettingsRows() {
      const getOpt = (key, opts, dict) => {
        const r = {
          id: key,
          title: key,
          selected: [this.userSettings[key]],
          options: opts || [false, true],
          dict,
        }
        return r
      }
      const res = {
        show_legacy_solutions: getOpt('show_legacy_solutions'),
        sw_actions_grouping: getOpt('sw_actions_grouping', [null, 'swv_grouping_none'], {
          null: 'remember',
          swv_grouping_none: 'dont-remember',
        }),
      }
      return res
    },
    specialRows() {
      const getOpt = (key, opts, dict) => {
        const r = {
          id: key,
          title: key === 'G1_no_poker_word' ? `${key}-needs refresh after login to work` : key,
          selected: [this.specialSettings[key]],
          options: opts || [false, true],
          dict,
        }
        return r
      }
      const res = {
        G1_no_poker_word: getOpt('G1_no_poker_word'),
      }
      return res
    },
    selectedSub() {
      return this.subs[0]
    },
  },
}
</script>
<style lang="scss" scoped>
.magic-login {
  max-width: 100vw;
  height: 100vh;
  padding: 1rem;
  flex: 1;
  width: 100%;
  position: absolute;
  border-radius: 4px;
  left: 0;
  z-index: 99;
  background: rgb(31, 31, 31);
  max-height: var(--vh-100);
  overflow: auto;
  .magic-btn {
    height: 24px !important;
    margin-top: 4px;
    text-align: left;
    background: var(--clr-black-3);
    border-radius: 4px;
    padding: 0 1rem;
    cursor: pointer;
  }
}

.magic_sub {
  padding: 1rem 1rem 0.5rem 1rem;
  background: rgb(44, 44, 44);
  border-radius: 8px;
  margin: 0 0 0.25rem 0;
}

.ch-param {
  padding: 0.5rem 1rem 0.75rem 1rem;
  background: rgb(32, 32, 32);
  border-radius: 8px;
  margin: 0 0.5rem 0.5rem 0;
}

.checkbox {
  height: 36px;
  display: flex;
  align-items: center;
}

.card {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid var(--clr-black-3);
}

/* Ensure long lines in <pre> and <code> wrap and do not cause horizontal scroll */
pre,
code {
  word-break: break-all;
  white-space: pre-wrap;
}
</style>
